<template>
	<div class="parent" style="height:calc(100vh - 50px);">
		<div style="height:30px; padding:15px; font-size:16px" id="jobInfoText"></div>
		<hr style="margin-left:25px;margin-right:25px;"/>
		<layout-3 :id=pageid :term=term :width=3 :height=4 style="max-height:30vh;"></layout-3>
		<hr style="margin-left:25px;margin-right:25px;"/>
		<layout-7 v-if="perms.includes('36')" :id=pageid3 :term=term :title="'Job Activities'" :binds="[5,6]" :edit_types="[null,null,null,'Employee','DateTime','Value',null]" :edit_perm="'37'" style="width:100%; height:calc(100vh - 480px);"></layout-7>
		<div class="nav-bar">
			<div>
				<button v-if="perms.includes('16')" v-on:click="button('Edit')">Edit Job Schedule</button>
			</div>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			perms:[],
			pageid:PAGES.SCHEDULES_VIEW_PAGE,
			pageid2:PAGES.SCHEDULE_JOB_INFO,
			pageid3:PAGES.EDIT_ACTIVITIES_PAGE,
		}
	},
	async created () {
		this.perms = api.getPerms();
		this.getJobData()
	},
	methods:{
		async button (name){
			api.postData(
				{
					type:"button",
					data:{
						pageid:this.pageid,
						buttonname:name,
					}
				}
			).then((res) => {
				if(res.data.data.to!=null) {
					if(res.data.data.useterm) {
						router.push('/'+res.data.data.to+'?q='+this.term);
					} else {
						router.push('/'+res.data.data.to);
					}
				}
			});
		},
		getJobData(){
			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid2,
						data:[
							this.term
						],
					}
				}
			).then((res) => {
				var text = ""
				for(var i = 0;i<res.data.data.column_names.length;i++){
					text+="<div style='float:left; height:30px'>"
					text+="<b>"+res.data.data.column_names[i]+":</b> "
					if(i==0){
						text+="<p style='float:right; height:30px;'>"+res.data.data.column_data[0][i]+"</p>"
					}else{
						text+=res.data.data.column_data[0][i]
					}
					text+="&emsp;</div>"
				}
				document.getElementById("jobInfoText").innerHTML = text;
			});
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/View_Schedules.vue